import integrationType from './integration-type';

export default {
  integrationType,
};
